import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useAppointments, Appointment } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Appointment>
      useData={useAppointments}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

